import {ethers} from 'ethers';
import ethereum from "decentralized/ethereum.js";
import {web3} from "decentralized/web3.js"
import AuthorizerContract from "decentralized/contracts/AuthorizerContract.js";
import accounts from "accounts/Accounts.js"
import BackendQuery from "decentralized/BackendQuery.js";
import EthereumTransaction from 'decentralized/transactions/EthereumTransaction.js';
import {AUTHORIZER} from 'decentralized/transactions/contracts.js';
import {AccountAuthorized} from "decentralized/EthereumEvents.js";

let contract = new AuthorizerContract();
const AUTH_MESSAGE = "I authorize publishing on zequencer.io from this ethereum address.";

export const getSigner = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    // Prompt user for account connections
    await provider.send("eth_requestAccounts", []);
    return provider.getSigner();
};

export const getAccounts = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    // Prompt user for account connections
    return await provider.send("eth_requestAccounts", []);
};


export const signMessage = async (msg) => {
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    // Prompt user for account connections
    let accounts = await provider.send("eth_requestAccounts", []);
    const signer = provider.getSigner();

    let flatSig = await signer.signMessage(msg);

    return {
        flatSignature: flatSig,
        splitSignature: ethers.utils.splitSignature(flatSig),
        account: accounts[0]
    };
};

export const authorizePublishing = async () => {
    let message = AUTH_MESSAGE;
    let {account, flatSignature, splitSignature} = await signMessage(message);

    // now store this signed message on the ropsten contract
    let {r,s,v} = splitSignature;
    new EthereumTransaction(
        AUTHORIZER, 'authorize',
        [account.toLowerCase(), message, v, r, s])
        .execute()
        .then(transactionHash => 0)
        .catch(err => 0);
};

export const isAuthorized = async () => {
    // check if we are authrozied
    const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
    if (!provider) {
        return false;
    }
    let walletAccounts  = await provider.send("eth_requestAccounts", []);
    if (!walletAccounts || !walletAccounts[0]) {
        return false;
    }
    let account = walletAccounts[0];

    // now check if theres any authorizations for this account and if it matches the account logged in
    // on zequencer's end

    let zequencerAccount = await accounts.getAccount();
    if (!zequencerAccount) {
        return false;
    }

    let query = new BackendQuery(contract.contractAddress)
        .from(AccountAuthorized)
        .where("walletAddress", account.toLowerCase());

    let results = await query.executeQuery();
    if (results.length === 0) {
        return false;
    }

    let result =  results[0];
    let {r,s,v} = result;

    r = '0x' + r;
    s = '0x' + s;

    v = web3.utils.numberToHex(v);
    let recovered = web3.eth.accounts.recover(AUTH_MESSAGE, v, r, s);
    if (!recovered) {
        return false;
    }
    return recovered.toLowerCase() === account.toLowerCase() ? account : false;
};


export const getAuthorizedCreatorName = async (creator) => {
    let query = new BackendQuery(contract.contractAddress)
        .from(AccountAuthorized)
        .where("walletAddress", creator.toLowerCase());

    let results = await query.executeQuery();
    if (results.length === 0) {
        return '';
    }

    let {zequencerAddress} = results[0];
    return await ethereum.users.getUserName(zequencerAddress);
};
